import { useFormik } from "formik";
import { toFormikValidationSchema } from "zod-formik-adapter";
import { createOrganisationSchema } from "../../../../../backend/src/schemas/organisationSchema";
import useOrganisationMutation, {
  OrganisationType,
} from "@/api/mutation/useOrganisationMutation";
import { isAxiosError } from "axios";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import useCurrentUserQuery from "@/api/query/useCurrentUserQuery";
import { useEffect, useState } from "react";
import Select, { SingleValue, MultiValue } from "react-select";
import { useNavigate } from "react-router-dom";
import countries from "../../../assets/json/countries.json";
import ErrorMessage from "@/components/common/ErrorMessage";
import { toast } from "react-toastify";
import { OrgStatusEnumValue } from "@backend/src/schemas/enums";
import { errorConfig } from "@/lib/toastError";
import { useTranslation } from "react-i18next";
import useCurruntLocationQuary from "@/api/query/useCurruntLocationQuary";
import Dialog from "@/components/common/Dialog";
import crossNew from "@/assets/svg/crossNew.svg";
import InputNumber from "@/components/common/InputNumber";
import { errorKeyFormate } from "@/helperFuntions/errroMessage";
import useUserProfileUpdateMutation from "@/api/mutation/useUserProfileUpdateMutation";
import { useUser } from "@/hooks/useUser";
import Loader from "@/components/common/Loader";
interface Props {
  editData?: OrganisationType & { userId: string };
}
type Options = { label: string; value: string };
const reactSelectStyleWorkingDays = {
  control: (
    provided: Record<string, unknown>,
    state: { isFocused: boolean }
  ) => ({
    ...provided,
    border: "0px solid #E7E7E7",
    paddingTop: "0.2rem",
    paddingBottom: "0.1rem",
    paddingLeft: "0.2rem",
    outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
    boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
    "&:hover": {
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: "0px 0px 0px #299d91",
    },
  }),
  option: (
    provided: Record<string, unknown>,
    state: { isSelected: boolean }
  ) => ({
    ...provided,
    color: state.isSelected ? "white" : "black",
    background: state.isSelected ? "#299d91" : "white",
    "&:hover": {
      color: "white",
      background: "#299d9199",
    },
  }),
  multiValueRemove: (base: Record<string, unknown>) => ({
    ...base,
    display: "flex",
    backgroundColor: "#787486",
    borderTopLeftRadius: "99px",
    borderBottomLeftRadius: "99px",
    borderTopRightRadius: "99px",
    borderBottomRightRadius: "99px",
    position: "absolute" as const,
    border: "1.5px solid white",
    padding: 0,
    top: "-4px",
    right: "-8px",
    zIndex: 10,
    width: "fit-content",
    color: "white",
    "&:hover": {
      backgroundColor: "#299d91aa",
    },
  }),
  multiValueLabel: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: `#299d91`,
    color: "white",
    borderRadius: "5px",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    paddingLeft: "0.5rem",
    paddingRight: "0.5rem",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
  }),
  multiValue: (base: Record<string, unknown>) => ({
    ...base,
    position: "relative" as const,
    backgroundColor: `#299d91`,
    color: "white",
    borderRadius: "5px",
    borderTopRightRadius: "5px",
    borderBottomRightRadius: "5px",
    marginRight: "7px",
  }),
} as const;

function OrganisationForm(props: Props) {
  const { editData } = props;
  const { t, i18n } = useTranslation();
  const labelStyle = "block text-gray-450/30 text-sm font-bold mb-1";
  const inputStyle =
    "block w-full p-2.5 border border-gray-100 text-gray-500 text-sm rounded-md shadow-sm placeholder:text-gray-400";
  const organisationMutation = useOrganisationMutation();

  const { refetch } = useCurrentUserQuery();
  const navigate = useNavigate();
  const [countryValue, setContryValue] = useState<SingleValue<Options>>();
  const [industryValue, setIndustryValue] = useState<SingleValue<Options>>();
  const [nonWorkingDaysValue, setNonWorkingDaysValue] =
    useState<MultiValue<Options>>();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isShowVideo, setIsShowVideo] = useState<boolean>(false);

  const formik = useFormik<z.infer<typeof createOrganisationSchema>>({
    initialValues: {
      organisationName: "",
      industry: "",
      status: OrgStatusEnumValue.ACTIVE,
      nonWorkingDays: [],
      country: "",
      phoneNumber: "",
      countryCode: "",
      createDemoProjects: false,
    },
    validationSchema: toFormikValidationSchema(createOrganisationSchema),
    onSubmit: (values, helper) => {
      if (values.phoneNumber) {
        values.phoneNumber.toString();
      }
      setIsSubmitting(true);

      organisationMutation.mutate(values, {
        onSuccess(data) {
          toast.success(data.data.message);
          localStorage.setItem(
            "organisation-id",
            data.data.data.organisationId
          );
          refetch().then(() => {
            navigate("/projects");
          });
          toast.success(t(`welcome_message`), {autoClose: false});
          setIsSubmitting(false);
        },
        onError(error) {
          if (isAxiosError(error)) {
            if (
              error.response?.status === 400 &&
              error.response.data?.errors &&
              Array.isArray(error.response?.data.errors)
            ) {
              error.response.data.errors?.map(
                (item: { message: string; path: [string] }) => {
                  helper.setFieldError(item.path[0], item.message);
                }
              );
            }
            if (!Array.isArray(error.response?.data.errors)) {
              toast.error(
                errorKeyFormate(error.response?.data.message + ""),
                errorConfig
              );
            }
          }
          setIsSubmitting(false);
        },
      });
    },
  });
  const { user } = useUser();
  useEffect(() => {
    if (!user?.isTutorialShow) {
      setIsShowVideo(true);
    }
  }, [user]);

  useEffect(() => {
    setNonWorkingDaysValue([nonWorkingDays[0], nonWorkingDays[6]]);
    formik.setFieldValue(
      "nonWorkingDays",
      [nonWorkingDays[0], nonWorkingDays[6]].map((item) => {
        return item.value;
      })
    );
    formik.setFieldValue("countryCode", "+1");
  }, []);

  const reactSelectStyle = {
    control: (
      provided: Record<string, unknown>,
      state: { isFocused: boolean }
    ) => ({
      ...provided,
      border: "0px solid #E7E7E7",
      paddingTop: "0.1rem",
      paddingBottom: "0.1rem",
      paddingLeft: "0.2rem",
      outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
      boxShadow: state.isFocused ? "0px 0px 0px #299d91" : "none",
      "&:hover": {
        outline: state.isFocused ? "2px solid #299d91" : "0px solid #E7E7E7",
        boxShadow: "0px 0px 0px #299d91",
      },
    }),
    option: (
      provided: Record<string, unknown>,
      state: { isSelected: boolean }
    ) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      background: state.isSelected ? "#299d91" : "white",
      "&:hover": {
        color: "white",
        background: "#299d9199",
      },
    }),
  };
  const locationQuary = useCurruntLocationQuary();
  useEffect(() => {
    if (
      locationQuary.data &&
      locationQuary.data?.data.data &&
      locationQuary.data?.data.data?.country
    ) {
      const val = countries.find(
        (d) => d.isoCode == locationQuary.data?.data.data?.country
      );
      if (val) {
        setContryValue({ label: val.name, value: val.isoCode });
        formik.setFieldValue("country", val.isoCode);
        formik.setFieldValue("countryCode", `+${val.phonecode}`);
      }
    }
  }, [locationQuary.data?.data.data]);

  const nonWorkingDays: Options[] = [
    { label: t("sunday"), value: "SUN" },
    { label: t("monday"), value: "MON" },
    { label: t("tuesday"), value: "TUE" },
    { label: t("wednesday"), value: "WED" },
    { label: t("thursday"), value: "THU" },
    { label: t("friday"), value: "FRI" },
    { label: t("saturday"), value: "SAT" },
  ];
  const industriesData: Options[] = [
    { label: t("Construction"), value: t("Construction") },
    { label: t("Educational_services"), value: t("Educational_services") },
    {
      label: t("Healthcare and Social assistance"),
      value: t("Healthcare and Social assistance"),
    },
    {
      label: t("Insurance, Banking, Finance"),
      value: t("Insurance, Banking, Finance"),
    },
    { label: t("Manufacturing"), value: t("Manufacturing") },
    { label: t("Marketing/PR"), value: t("Marketing/PR") },
    { label: t("Non-Profit"), value: t("Non-Profit") },
    {
      label: t("Technology & Telecommunication"),
      value: t("Technology & Telecommunication"),
    },
    { label: t("Others"), value: t("Others") },
  ];

  const contrysFn = () => {
    const value = countries.map((item) => {
      return { label: item.name, value: item.isoCode };
    });
    return value;
  };
  const contryCode = () => {
    const value = countries.map((item) => {
      return {
        label: "+" + item.phonecode + " " + item.name,
        value: "+" + item.phonecode,
      };
    });
    const seenValues = new Set();
    const uniqueArray = value
      .filter((item) => {
        if (seenValues.has(item.value)) {
          return false;
        }
        seenValues.add(item.value);
        return true;
      })
      .sort((a, b) => {
        const numA = parseInt(a.value.substring(1));
        const numB = parseInt(b.value.substring(1));
        return numA - numB;
      });

    return uniqueArray;
  };
  const handleCountry = (val: SingleValue<Options>) => {
    if (val) {
      setContryValue(val);
      formik.setFieldValue("country", val.value);
      formik.setFieldValue(
        "countryCode",
        "+" + countries.find((c) => c.isoCode == val.value)?.phonecode
      );
    }
  };
  const handleNonWorkingDays = (val: MultiValue<Options>) => {
    const filteredVal = val.filter((item) => item.label !== t("none"));
    setNonWorkingDaysValue(filteredVal);
    formik.setFieldValue(
      "nonWorkingDays",
      filteredVal.map((item) => item.value)
    );
  };
  const handleIndustries = (val: SingleValue<Options>) => {
    if (val) {
      setIndustryValue(val);
      formik.setFieldValue("industry", val.value);
    }
  };
  const userProfileUpdateMutation = useUserProfileUpdateMutation();
  const setIsTutorialShow = () => {
    userProfileUpdateMutation.mutate(
      {
        firstName: user?.firstName ?? "",
        lastName: user?.lastName ?? "",
        country: user?.country ?? "",
        email: user?.email ?? "",
        isTutorialShow: true,
      },
      {
        onSettled() {
          refetch();
        },
      }
    );
  };
  
  return (
    <div className="bg-white rounded-lg px-2.5 md:px-6 lg:px-8 pt-6 pb-8 mb-4 w-full">
      {isSubmitting && <Loader className="absolute h-full w-full top-0 left-0 bg-white z-20" message={t("create_demo_projects_message")} />}
      <div className="flex justify-between items-center my-1 mb-5">
        <h1 className="text-2xl md:text-4xl font-bold text-gray-900">
          {editData && editData.organisationId
            ? t("update_organisation")
            : t("create_your_organization")}
        </h1>
        <div>
          <Button
            type="submit"
            variant={"primary"}
            onClick={async () => {
              await formik.validateForm().then(() => {
                formik.handleSubmit();
              });
            }}
            isLoading={isSubmitting}
            disabled={isSubmitting}
            className="w-full py-2.5 px-9 mt-5 rounded-md hover:bg-opacity-80 disabled:bg-opacity-50"
          >
            {t("next")}
          </Button>
        </div>
      </div>
      <form
        onSubmit={(e) => e.preventDefault()}
        className="md:grid grid-cols-1 md:grid-cols-2 gap-5 md:w-2/3"
      >
        <div className="col-span-2">
          <label className={labelStyle}>
            {t("organisation_name")}
            <span className="ml-0.5 text-red-500">*</span>
          </label>
          <input
            className={inputStyle}
            name="organisationName"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.organisationName}
            type="text"
            placeholder={t("organisation_name")}
          />

          <ErrorMessage>
            {formik.touched.organisationName && formik.errors.organisationName}
          </ErrorMessage>
        </div>
        <div>
          <label className={labelStyle}>
            {t("industry")}
            <span className="ml-0.5 text-red-500">*</span>
          </label>
          <Select
            className={`${inputStyle} select !p-0`}
            onChange={handleIndustries}
            onBlur={() => formik.setTouched({ industry: true })}
            options={industriesData}
            value={industryValue}
            name="industry"
            placeholder={t("industry")}
            styles={reactSelectStyle}
          />
          <ErrorMessage>
            {formik.touched.industry && formik.errors.industry}
          </ErrorMessage>
        </div>
        <div>
          <label className={labelStyle}>
            {t("non_working_days")}
            <span className="ml-0.5 text-red-500">*</span>
          </label>
          <Select
            key={i18n.language}
            className={`${inputStyle} select !p-0`}
            onChange={handleNonWorkingDays}
            onBlur={() => formik.setTouched({ nonWorkingDays: true })}
            options={nonWorkingDays}
            value={nonWorkingDaysValue?.map((r) => {
              return { label: t(r.label), value: r.value };
            })}
            defaultValue={nonWorkingDaysValue?.map((r) => {
              return { label: t(r.label), value: r.value };
            })}
            name="nonWorkingDays"
            placeholder={t("non_working_days")}
            isMulti
            styles={reactSelectStyleWorkingDays}
          />
          <ErrorMessage>
            {formik.touched.nonWorkingDays && formik.errors.nonWorkingDays}
          </ErrorMessage>
        </div>
        <div>
          <label className={labelStyle}>
            {t("country")}
            <span className="ml-0.5 text-red-500">*</span>
          </label>
          <Select
            className={`${inputStyle} select !p-0`}
            onChange={handleCountry}
            onBlur={() => formik.setTouched({ country: true })}
            options={contrysFn()}
            value={countryValue}
            placeholder={t("country")}
            name="country"
            styles={reactSelectStyle}
          />
          <ErrorMessage>
            {formik.touched.country && formik.errors.country}
          </ErrorMessage>
        </div>
        <div className="text-left flex gap-2">
          <div className="w-1/2">
            <label className={labelStyle + "mb-0"}>{t("country_code")}</label>
            <Select
              className={`${inputStyle} select !p-0 mt-1`}
              onChange={(e) => {
                formik.setFieldValue("countryCode", e?.value ? e.value : "");
              }}
              onBlur={() => formik.setTouched({ countryCode: true })}
              options={contryCode()}
              value={{
                label: contryCode().find(
                  (c) => c.value == formik.values.countryCode
                )?.label,
                value: formik.values.countryCode,
              }}
              defaultValue={{
                label: contryCode().find(
                  (c) => c.value == formik.values.countryCode
                )?.label,
                value: formik.values.countryCode,
              }}
              placeholder={t("country_code")}
              name="countryCode"
              menuPlacement="top"
              styles={reactSelectStyle}
            />
            <ErrorMessage>
              {formik.touched.countryCode && formik.errors.countryCode}
            </ErrorMessage>
          </div>
          <div className=" w-1/2">
            <label className={labelStyle}>{t("phone_number")}
            <span className="ml-0.5 text-red-500">*</span></label>
            <InputNumber
              name="phoneNumber"
              placeholder={t("phone_number")}
              className={inputStyle}
              value={formik.values.phoneNumber ?? ""}
              onChange={(e) => formik.setFieldValue("phoneNumber", e.target.value.toString())}
              onBlur={formik.handleBlur}
            />
            <ErrorMessage>
              {formik.touched.phoneNumber && formik.errors.phoneNumber}
            </ErrorMessage>
          </div>
        </div>

        {/* <div className="w-full flex justify-start items-center gap-2 ml-2">
          <input
            type="checkbox"
            name="createDemoProjects"
            className={inputStyle + " !w-fit"}
            checked={formik.values.createDemoProjects}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          <label className={labelStyle}>Create a demo project</label>
        </div> */}
      </form>
      {isShowVideo && (
        <Dialog
          isOpen={isShowVideo}
          onClose={() => {}}
          modalClass="rounded-lg  h-[90%] w-[85%] py-4 flex flex-col overflow-hidden relative"
        >
          <div className="mt-3 mr-5 justify-end shadow-sm  absolute top-2 right-2 z-50 rounded-full p-3 bg-gray-500/30">
            <img
              src={crossNew}
              className="w-5 min-5 brightness-0 cursor-pointer"
              onClick={() => {
                setIsShowVideo(false), setIsTutorialShow();
              }}
            />
          </div>
          <div className="relative w-full h-full">
            <iframe
              src="https://player.vimeo.com/video/998692707?h=f6ba6f65f9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
              allowFullScreen
              allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              title="ProjectChef Demo"
            ></iframe>
          </div>
        </Dialog>
      )}
    </div>
  );
}
export default OrganisationForm;
